import styled from "styled-components";
import { BaseStyle } from "./styled";

export const StudyNoticeListStyle = styled(BaseStyle)`
  .container {
    text-align: left;
  }

  .notice-list-title {
    font-size: 25px;
    font-weight: bold;
    text-align: left;
    padding: 20px 0;
    font-family: "Pretendard";
  }

  .offcanvas-body {
    text-align: left;
  }

  .offcanvas-button {
    text-align: right;
  }
`;
